import Rebase from 're-base';
import * as firebase from 'firebase';

const app = firebase.initializeApp( {
    apiKey: process.env.REACT_APP_FIREBASE_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_FIRESTONE,
    messagingSenderId:process.env.REACT_APP_FIREBASE_MESSAGING

})

const base = Rebase.createClass(app.database())
const facebookProvider = new firebase.auth.FacebookAuthProvider()


export { base, app, facebookProvider }


// WEBPACK FOOTER //
// ./src/base.jsx